import React, { useEffect, useState } from "react";
import { IconButton, Menu, MenuItem, Typography } from "@mui/material";
import { logoutUser } from "../../Redux/Actions/authAction";
import { LockOpen } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import CropFreeIcon from "@mui/icons-material/CropFree";
import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen";
import { LOCAL_STORAGE } from "Components/Constants/LocalStorage";
import { GET_LOCAL_STORAGE } from "Components/Constants/GetLocalStorage";
import { company } from "titum-custom/details";
import BackupService from "Service/Accounts/Backup.service";
import AddCashInOut from "Components/Sales/POS/CashInOut/addCashInOut";
import CloseIcon from "@mui/icons-material/Close";

export default function LogoutMenu(props) {
  const [isLoggedIn, setIsLoggedIn] = useState(
    !!localStorage.getItem("sessionId")
  );
  const currentSessionId = localStorage.getItem("sessionId");

  // console.log(currentSessionId);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const dispatch = useDispatch();
  const defaultLocationSelected = useSelector((state) => state.defaultLocation);

  const [fullScreen, setFullScreen] = useState(false);

  const [showCashOutPopup, setShowCashOutPopup] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "sessionId") {
        setIsLoggedIn(!!event.newValue); // Update login state based on session ID
        dispatch(logoutUser());
      }
    };

    const handleShowCashOutPopup = () => {
      setShowCashOutPopup(true);
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [currentSessionId]);
  const handleClose = () => {
    localStorage.removeItem("sessionId"); // Broadcast logout across tabs

    dispatch(logoutUser());
  };

  const handleBackup = async () => {
    const res = await BackupService.download();
  };

  var elem = document.documentElement;
  function openFullscreen() {
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) {
      /* Safari */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      /* IE11 */
      elem.msRequestFullscreen();
    }
    setFullScreen(true);
  }
  function closeFullscreen() {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      /* Safari */
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      /* IE11 */
      document.msExitFullscreen();
    }
    setFullScreen(false);
  }

  return (
    <div style={{ position: "absolute", right: 15 }}>
      Location:{" "}
      {JSON.parse(localStorage.getItem(LOCAL_STORAGE.BIZX_LOCATION)).name}
      <IconButton
        color="inherit"
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={() => {
          !fullScreen ? openFullscreen() : closeFullscreen();
        }}
      >
        <p
          style={{ marginLeft: 5, marginRight: 5, textTransform: "uppercase" }}
        >
          {!fullScreen ? "Full Screen  [ F11 ]" : "Close  [ F11 ]"}
        </p>
        {!fullScreen ? <CropFreeIcon /> : <CloseFullscreenIcon />}
      </IconButton>
      <IconButton
        color="inherit"
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <p
          style={{ marginLeft: 5, marginRight: 5, textTransform: "uppercase" }}
        >
          {" "}
          {props.user}
        </p>
        <LockOpen />
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => {
          setAnchorEl(null);
        }}
      >
        <a href={company.backup} target="_blank" rel="noopener noreferrer">
          <MenuItem style={{ color: "blue" }}>Backup</MenuItem>
        </a>
        <MenuItem>
          <NavLink
            to="cash-in-out"
            exact
            style={{ textDecoration: "none", color: "inherit" }}
          >
            Add Cash In/Out
          </NavLink>
        </MenuItem>
        <NavLink to="settings" exact>
          <MenuItem>Settings</MenuItem>
        </NavLink>
        <MenuItem onClick={() => handleClose()}>Logout</MenuItem>
      </Menu>
      {/* Cash In/Out Component */}
      {showCashOutPopup && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              background: "white",
              borderRadius: "10px",
              textAlign: "center",
              width: "800px",
            }}
          >
            <div
              style={{
                background: "#202335",
                padding: "18px",
                color: "#FFFFFF",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                overflow: "hidden",
              }}
            >
              <Typography variant="h6">
                Please Enter{" "}
                <span style={{ fontWeight: 600, fontSize: "18px" }}>
                  Cash-Out!
                </span>
              </Typography>

              {/* Close icon */}
              <div
                style={{ cursor: "pointer" }}
                onClick={() => setShowCashOutPopup(false)}
              >
                <CloseIcon />
              </div>
            </div>

            <div style={{ padding: "20px 0px" }}>
              <AddCashInOut
                setOpen={setShowCashOutPopup}
                popupState={showCashOutPopup}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
